import { ConfigData } from 'types/interfaces';

export const IDENTITY_VALIDATION_STEP_ID = 'SAFEID_STEP';

const config: ConfigData = {
  ID: IDENTITY_VALIDATION_STEP_ID,
  SIDEBAR_MENU: true,
  PROGRESS_BAR: true,
  PROGRESS_BAR_COUNT: true,
  FOOTER: true,
  BUTTON_HELP: true,
  BUTTON_LANG: true,
  BUTTON_QUIT: true,
  BUTTON_CONTINUE: false,
  FOOTER_DIVIDER: false,
};

export default config;
